import React from "react";
import {
  Input,
  InputNumber,
  Checkbox,
  Form,
  Switch,
  DatePicker,
  Select,
} from "antd";
import { dateFormatList } from "constants";
import { dateTimeFormatList } from "constants";
import { formatterNumber, parserNumber } from "utils/helper";

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,

  isRequired = false,
  min = 0,
  ...restProps
}) => {
  const inputNode =
    inputType === "number" ? (
      <InputNumber
        placeholder={title}
        min={min}
        formatter={(value) => formatterNumber(value)}
        parser={(value) => parserNumber(value)}
        style={{
          width: "100%",
        }}
      />
    ) : inputType === "checkbox" ? (
      <Checkbox />
    ) : inputType === "switch" ? (
      <Switch />
    ) : inputType === "select" ? (
      <Select
        placeholder={title}
        // value={record.groupId}
        options={restProps?.options || []}
        allowClear
        onChange={(value) => restProps?.onChange && restProps.onChange(value)}
        showSearch
        optionFilterProp="children"
        filterOption={(input, option) =>
          (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
        }
        filterSort={(optionA, optionB) =>
          (optionA?.label ?? "")
            .toLowerCase()
            .localeCompare((optionB?.label ?? "").toLowerCase())
        }
        mode={restProps?.mode || ""}
      />
    ) : inputType === "date" ? (
      <DatePicker placeholder={title} format={dateFormatList} />
    ) : inputType === "datetime" ? (
      <DatePicker
        placeholder={title}
        format={dateTimeFormatList}
        showTime={{ format: "HH:mm" }}
      />
    ) : (
      <Input placeholder={title} />
    );
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={restProps?.isFormList ? [record.key, dataIndex] : dataIndex}
          style={{ margin: 0 }}
          valuePropName={
            ["checkbox", "switch"].includes(inputType) ? "checked" : "value"
          }
          rules={[
            {
              required: isRequired,
              message: `bắt buộc`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

export default EditableCell;
